import { AdminApi, DefaultApi } from './generated';

const apiUrl = process.env.REACT_APP_API_BASE_URL;

export const api = new DefaultApi(undefined, apiUrl);
export const adminApi = new AdminApi(undefined, apiUrl);